import React from "react";
import PerformanceAnalysisChampionCircle from "./PerformanceAnalysisChampionCircle";

const PerformanceAnalysisAllTheDamage = (props) => {
  const { allTheDamage } = props;

  if (!allTheDamage) {
    return <div />;
  }
  const { bestCsPerMin, bestDamagePerDeath, bestKda, bestWinRate } = allTheDamage;
  const damageStats = [
    { champID: bestCsPerMin.championId, statText: bestCsPerMin.csPerMin.toFixed(1), label: "AVG CS / MIN" },
    { champID: bestDamagePerDeath.championId, statText: bestDamagePerDeath.damagePerDeath.toFixed(0), label: "DAMAGE PER DEATH" },
    { champID: bestKda.championId, statText: bestKda.kda.toFixed(1), label: "KDA" },
    { champID: bestWinRate.championId, statText: `${(bestWinRate.winRate * 100).toFixed(0)}%`, label: "WIN RATE" },
  ];

  return (
    <div className="all-the-damage">
      <div className="text-header">
        <div className="small-header">TONS OF DAMAGE</div>
        <div className="basic-text">Look at the KDA, LOOK AT THE MOVES! Here are your best champs per category this season.</div>
      </div>
      <div className="champ-container">
        {damageStats.map((stat, index) => {
          return <PerformanceAnalysisChampionCircle key={index} data={stat} />;
        })}
      </div>
    </div>
  );
};

export default PerformanceAnalysisAllTheDamage;
